import { Role } from './role';
import { Permission } from './permission';

export class User {
    constructor(
        public id = 0,
        public idNumber = '',
        public username = '',
        public firstName = '',
        public lastName = '',
        public email = '',
        public phone = '',
        public mobilePhone = '',
        public address = '',
        public mobileSessionEnabled = 1,
        public state = 1,
        public role = new Role(),
        public isSystem: number = 0
    ) {}

    get name() {
        return this.firstName + ' ' + this.lastName;
    }
    static fromJSON(data: any): User {
        const permissions = Array.isArray(data?.role?.permissions)
            ? data.role.permissions.map((permission: any) => new Permission(
                permission.id,
                permission.name,
                permission.action ?? '',
                permission.menu?.route ?? ''
            ))
            : [];

        const role = new Role(
            data?.role?.id ?? 0,
            data?.role?.name ?? '',
            permissions
        );
        return new User(
            data?.id ?? 0,
            data?.idNumber ?? '',
            data?.username ?? '',
            data?.firstName ?? '',
            data?.lastName ?? '',
            data?.email ?? '',
            data?.phone ?? '',
            data?.mobilePhone ?? '',
            data?.address ?? '',
            data?.mobileSessionEnabled ?? 1,
            data?.state ?? 1,
            role,
            data?.isSystem ?? 0
        );
    }    
}
